<div class="content p-24">
  <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2">

    <mat-tab-group>
        <mat-tab label="Gegevens"> 
            <div class="example-viewer-body">
              <div class="example-container">
                  <mat-form-field>
                    <input matInput [(ngModel)]="voornaamvalue" placeholder="Voornaam">
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [(ngModel)]="achternaamvalue" placeholder="Achternaam">
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [(ngModel)]="emailvalue" placeholder="Email">
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [(ngModel)]="mobielprivevalue" placeholder="Telefoon mobiel prive">
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [(ngModel)]="mobielwerkvalue" placeholder="Telefoon mobiel werk">
                  </mat-form-field>
                  <mat-form-field>
                      <input matInput [(ngModel)]="geboortedatumvalue"  [matDatepicker]="geboortedatum" placeholder="Geboortedatum">
                      <mat-datepicker-toggle matSuffix [for]="geboortedatum"></mat-datepicker-toggle>
                      <mat-datepicker #geboortedatum></mat-datepicker>
                  </mat-form-field>
                  <div fxLayout="row">
                    <mat-form-field>
                        <input matInput [(ngModel)]="tvtstartvalue" placeholder="Tvt start uur">
                    </mat-form-field>
                    <mat-form-field>
                      <input matInput [(ngModel)]="vakantiestartuurvalue" placeholder="Vakantie start uur">
                    </mat-form-field>
                    <mat-form-field>
                      <input matInput [(ngModel)]="contractuurvalue" placeholder="Contract uur">
                    </mat-form-field>
                  </div>
                  <div fxLayout="row">
                    <mat-form-field>
                      <input matInput [(ngModel)]="nettouurtariefvalue" placeholder="Netto uur tarief">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput [(ngModel)]="inhuurkrachttariefvalue" placeholder="Inhuurkracht tarief">
                      </mat-form-field>
                  </div>
                  <mat-checkbox  [(ngModel)]="inplanbaarvalue">Inplanbaar</mat-checkbox>
                </div>
                <fieldset>
                    <legend>Dienstverband:</legend>
                    <mat-radio-group [(ngModel)]="dienstverbandvalue" class="example-radio-group">
                      <mat-radio-button class="example-radio-button"  [value]="1">In dienst</mat-radio-button>
                      <mat-radio-button class="example-radio-button"  [value]="2">Inhuurkracht</mat-radio-button>
                      <mat-radio-button class="example-radio-button" [value]="0">Uit dienst / geen contract meer</mat-radio-button>
                    </mat-radio-group>  
                </fieldset>
                <div class = "opslaanclass" fxLayout="row">
                    <button mat-raised-button>Terug</button>
                    <button style = "margin-left:20px;" mat-raised-button (click)="saveMedewerker()" color="accent">Opslaan</button>
                    <button style = "margin-left:20px;" mat-raised-button color="warn">Verwijderen    </button>
                </div>
            </div>

        </mat-tab>
        <mat-tab label="Rechten">
          
          Rechten 

        </mat-tab>
        <mat-tab label="Tarief"> 
          
          Tarieven
        </mat-tab>
    </mat-tab-group>
  
  </div>


</div>